;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.services')
    .service('TokenSwitcherService', TokenSwitcherService)

  TokenSwitcherService.$inject = [
    // Angular
    '$http', '$q',
    // Libs
    'zlAuth',
    // Managers
    // Services
    'SessionService',
    // Const
    'apps', 'urls'
    // Resolved
  ]

  function TokenSwitcherService (
    // Angular
    $http, $q,
    // Libs
    zlAuth,
    // Managers
    // Services
    SessionService,
    // Const
    apps, urls
    // Resolved
  ) {
    var self = this

    _.extend(self, {
      // Public Attributes
      // Public Methods
      switchApp: switchApp,
      accessibleApps: apps
    })

    function switchApp (application, ignoreFails = false) {
      if (!application) {
        application = ''
      }
      var appId
      switch (application.toLowerCase()) {
        case 'soli':
        case 'solitech':
        case 'solica':
          appId = apps.SOLITECH
          break
        case 'loka':
        case 'lokatech':
        case 'parkour':
          appId = apps.LOKATECH
          break
        case 'fluid':
        case 'fluidtech':
          appId = apps.FLUIDTECH
          break
        case 'alia':
          appId = apps.ALIATECH
          break
      }

      if (!appId) {
        return $q.reject('Unknown app')
      }

      return zlAuth.getToken().then(function (token) {
        return $http.post(urls.auth + '/token/switch',
          {
            company: SessionService.getCompany(),
            application: appId
          },
          {
            headers: {
              Accept: 'application/json'
            },
            ignoreErrors: ignoreFails ? [401] : []
          }
        )
      }).then(function (data) {
        return data.data.token
      })

    }
  }
})(window.angular, window._)
